export const mockDisciplines = ['Physiotherapy', 'Massage Therapy', 'Chiropractic'];

export const mockDoctors = {
  'Physiotherapy': [
    { 
      id: 1, 
      name: 'Dr. John Doe', 
      bio: 'Dr. John has been practicing physiotherapy for over 15 years, specializing in sports injuries.', 
      subBio: 'Dr. John Doe is a well-respected physiotherapist with over 15 years of experience treating sports injuries. His approach combines traditional physiotherapy techniques with the latest advancements in rehabilitation science. He has worked with professional athletes and teams, helping them recover from injuries and prevent future issues. Dr. Doe is known for his patient-centered care and dedication to empowering patients to take control of their recovery process. In addition to his clinical work, Dr. John frequently presents at national conferences on sports injury rehabilitation.',
      specialties: ['Sports Injuries', 'Post-Surgery Rehab'], 
      achievements: 'Best Physiotherapist Award 2019', 
      image: '/images/d1.jpeg', 
      experience: 15 
    },
    { 
      id: 4, 
      name: 'Dr. Alice Brown', 
      bio: 'Dr. Alice is dedicated to helping patients recover from musculoskeletal injuries.', 
      subBio: 'Dr. Alice Brown is an expert in physiotherapy with a specialization in post-surgery rehabilitation and chronic pain management. She is a strong advocate of incorporating holistic treatments such as yoga and mindfulness into traditional physiotherapy. Alice\'s commitment to continuous learning keeps her at the forefront of the latest rehabilitation techniques. Outside of work, Dr. Brown enjoys volunteering at local community health clinics and mentoring the next generation of physiotherapists.',
      specialties: ['Manual Therapy', 'Orthopedic Rehab'], 
      achievements: 'Excellence in Physical Therapy 2020', 
      image: '/images/d2.jpeg', 
      experience: 12 
    },
    { 
      id: 5, 
      name: 'Dr. Chris Evans', 
      bio: 'Dr. Chris focuses on movement-based recovery and sports injury prevention.', 
      subBio: 'Dr. Chris Evans is a seasoned physiotherapist with over 12 years of experience, focusing on musculoskeletal conditions and sports injuries. His dynamic treatment approach blends manual therapy, therapeutic exercises, and cutting-edge modalities. Known for his friendly demeanor, he strives to ensure his patients feel comfortable throughout their recovery. In his spare time, Dr. Chris conducts workshops for amateur athletes on injury prevention and physical conditioning.',
      specialties: ['Kinesiology', 'Sports Therapy'], 
      achievements: 'Lead Trainer for the National Sports Team', 
      image: '/images/d3.jpeg', 
      experience: 10 
    }
  ],
  'Massage Therapy': [
    { 
      id: 2, 
      name: 'Dr. Jane Smith', 
      bio: 'Dr. Jane specializes in therapeutic massage for chronic pain relief.', 
      subBio: 'Dr. Jane Smith is a massage therapist with over 10 years of experience, specializing in deep tissue massage and trigger point therapy. Her therapeutic techniques are aimed at relieving tension, improving circulation, and promoting overall well-being. She takes a holistic approach, focusing on both physical health and mental clarity. Dr. Smith collaborates with other healthcare professionals to create comprehensive care plans for her clients.',
      specialties: ['Chronic Pain', 'Deep Tissue Massage'], 
      achievements: 'Certified in Deep Tissue Therapy', 
      image: '/images/d4.jpeg', 
      experience: 10 
    },
    { 
      id: 6, 
      name: 'Dr. Mary Jane', 
      bio: 'Dr. Mary has helped patients manage pain through advanced massage techniques.', 
      subBio: 'Dr. Mary Jane is a certified massage therapist with expertise in prenatal and sports massage. She has a deep understanding of human anatomy, allowing her to pinpoint the sources of pain and tension. Mary is passionate about helping patients achieve a state of balance, both physically and mentally. When not in the clinic, Dr. Mary teaches massage therapy techniques at local wellness seminars and workshops.',
      specialties: ['Myofascial Release', 'Trigger Point Therapy'], 
      achievements: 'Awarded Top Therapist in 2021', 
      image: '/images/d1.jpeg', 
      experience: 8 
    },
    { 
      id: 7, 
      name: 'Dr. Luke Cage', 
      bio: 'Dr. Luke focuses on healing injuries through relaxation and tension release techniques.', 
      subBio: 'Dr. Luke Cage is known for his strong hands and intuitive touch, specializing in neuromuscular massage and pain relief therapy. With over 15 years of experience, he integrates a variety of massage techniques to help his clients recover and rejuvenate. His personalized treatment plans are tailored to the specific needs of each client, ensuring maximum results and long-term relief.',
      specialties: ['Swedish Massage', 'Injury Recovery'], 
      achievements: 'Certified Therapeutic Massage Expert', 
      image: '/images/d6.jpeg', 
      experience: 9 
    }
  ],
  'Chiropractic': [
    { 
      id: 3, 
      name: 'Dr. Emily Johnson', 
      bio: 'Dr. Emily specializes in spinal adjustments and posture correction.', 
      subBio: 'Dr. Emily Johnson is a highly skilled chiropractor specializing in spinal health, posture correction, and holistic wellness. With over a decade of experience, she has helped patients recover from back injuries and postural imbalances. Dr. Emily emphasizes the importance of spinal health as the foundation for overall well-being and incorporates lifestyle changes into her treatment protocols.',
      specialties: ['Spinal Adjustments', 'Posture Correction'], 
      achievements: 'Top Chiropractor 2020', 
      image: '/images/d7.jpeg', 
      experience: 12 
    },
    { 
      id: 8, 
      name: 'Dr. Tony Stark', 
      bio: 'Dr. Tony combines advanced technology with chiropractic care to treat spinal conditions.', 
      subBio: 'Dr. Tony Stark is an innovative chiropractor with a passion for advanced spinal correction and sports rehabilitation. He utilizes the latest chiropractic techniques to relieve pain and improve his patients\' overall health. Dr. Stark has a particular interest in helping athletes recover from injuries and improve their performance.',
      specialties: ['Neurospinal Care', 'Posture Realignment'], 
      achievements: 'Innovator in Neurospinal Therapies', 
      image: '/images/d8.jpeg', 
      experience: 14 
    },
    { 
      id: 9, 
      name: 'Dr. Bruce Wayne', 
      bio: 'Dr. Bruce is known for his precise spinal manipulation techniques.', 
      subBio: 'Dr. Bruce Wayne is an experienced chiropractor with a focus on treating complex spinal issues, including herniated discs and sciatica. With over 20 years in practice, Dr. Wayne blends chiropractic care with physical therapy to address the root causes of pain and ensure long-term relief.',
      specialties: ['Manual Manipulation', 'Sports Chiropractic'], 
      achievements: 'Chiropractor of the Year 2019', 
      image: '/images/d9.jpeg',  
      experience: 16 
    }
  ]
};
